import React, { useEffect, useRef } from "react";
import animationData from "../../../../assets/json/lotties/No-History.json";

const LottieEmptyState = ({ 
  title = "No Data Available", 
  subtitle = "Data will appear here when available",
  height = 200,
  width = 200,
  className = ""
}) => {
  const animationRef = useRef();

  const getLottie = async () => {
    try {
      const lot = await import("lottie-web");

      if (animationRef.current) {
        lot.default.loadAnimation({
          loop: true,
          autoplay: true,
          animationData: animationData,
          container: animationRef.current,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        });
      }
    } catch (error) {
      console.error("Error loading Lottie animation:", error);
    }
  };

  useEffect(() => {
    getLottie();
  }, []);

  return (
    <div className={`flex flex-col items-center justify-center py-8 ${className}`} style={{ height: `${height}px` }}>
      <div 
        ref={animationRef} 
        style={{ 
          width: `${width}px`, 
          height: `${width}px`,
          maxWidth: "100%"
        }}
      />
      <div className="text-center mt-1">
        <div className="text-lg font-medium text-gray-600 dark:text-gray-300">
          {title}
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          {subtitle}
        </div>
      </div>
    </div>
  );
};

export default LottieEmptyState;
